export const home_i18n = {
    text1: "Envoyez votre premier check-in à signer",
    text2: "Le check-in virtuel recueille les données biométriques du client et les associe à sa réservation.",
    text3: "Envoyer le check-in",
    text4: 'Accueil',
    text5: "Check-in",
    text6: "Bienvenue",
    text7: "Configuration du check-in",
    text8: "mon compte",
    text9: "Configuration du check-in",
    text10: "Déconnexion",
    text11: "Image de l'hôtel",
    text12: "Politiques de l'hôtel",
    text13: "messages de bienvenue",
    text14: "Téléchargez le logo de votre hôtel",
    text15: "Sélectionnez ou faites glisser le logo",
    text16: "Annuler",
    text17: "Nom de l'hôtel",
    text18: "Enregistrer les modifications",
    text19: "Changer de logo",
    text20: "Télécharger",
    text21: "Historique des signatures",
    text22: "Panneau de contrôle des documents signés par les clients.",
    text23: "Filtre :",
    text24: "Désactivé",
    text25: "Par date",
    text26: "Par pays",
    text27: "Prénom",
    text28: "Nom",
    text29: "Nationalité",
    text30: "Date d'arrivée",
    text31: "Synchronisé",
    text32: "Options",
    text33: "Aucune donnée",
    text34: "Lignes par page :",
    text35: "Rechercher",
    text36: "Pays",
    text37: "Du",
    text38: "Au",
    text39: "COPYRIGHT © 2022 , Tous droits réservés WACheckines",
    text40: "Fait avec",
    text41: "Exporter",
    text42: "Voir le détail",
    text43: "Voir le PDF signé",
    text44: "Supprimer",
    text45: "Sélectionner une option",
    //aca
    text46: "Ajouter un moyen de paiement",
    text47: "Enregistrez ou mettez à jour le moyen de paiement sur lequel les prélèvements mensuels seront effectués.",
    text48: "Dette totale",
    text49: "Paiement réussi",

    p1: "Vous êtes sur la version d'essai",
    p2: "Vous avez",
    p3: "jours restants !",
    p4: "La période d'essai est terminée.",
    p5: "Abonnez-vous maintenant",
    p6: "Votre essai gratuit est terminé !",

};
